import { useEffect, useState } from 'react';

export const highContrastMode = window.matchMedia('(forced-colors: active)').matches;

export const useHighContrastMode = () => {
  const [isHighContrast, setIsHighContrast] = useState(false);

  useEffect(() => {
    const highContrastQuery = window.matchMedia('(forced-colors: active)');

    const handleHighContrastChange = (event: any) => {
      setIsHighContrast(event.matches);
    };

    highContrastQuery.addEventListener('change', handleHighContrastChange);

    handleHighContrastChange(highContrastQuery);

    return () => {
      highContrastQuery.removeEventListener('change', handleHighContrastChange);
    };
  }, []);

  return isHighContrast;
};
